import { signal } from "@angular/core";
import { Environment } from "../models/environment.model";
import { toObservable } from "@angular/core/rxjs-interop";

export class EnvironmentService {
  private readonly _environment = signal<Environment>(undefined);
  public readonly environment = this._environment.asReadonly();
  public readonly environment$ = toObservable(this._environment);

  constructor(environment: Environment) {
    this._environment.set(environment);
  }
}
